var map = {
	"./Googleicon.svg": "588a",
	"./History.svg": "1993",
	"./Info.svg": "90b8",
	"./Play (播放).svg": "c166",
	"./Tips_提示.svg": "c31d",
	"./correct.svg": "4c0f",
	"./error.svg": "28c3",
	"./logo.svg": "5b1c",
	"./market_Play_icon.svg": "333e",
	"./market_arrow_right.svg": "93fc",
	"./market_icon_check.svg": "468e",
	"./market_icon_right.svg": "d79a",
	"./new.svg": "bdaf",
	"./orderflow1.svg": "63c1",
	"./orderflow2.svg": "aef3",
	"./orderflow3.svg": "278a",
	"./orderflow4.svg": "f674",
	"./orderflow5.svg": "0c17",
	"./orderflow6.svg": "97bd",
	"./pencil.svg": "e51f",
	"./sort.svg": "f931",
	"./stock.svg": "2f62",
	"./zaiku.svg": "c9ec",
	"./zhifa.svg": "0ef0",
	"./关闭弹窗.svg": "2cdd",
	"./创建.svg": "0ba1",
	"./创建成功.svg": "70e2",
	"./勾.svg": "8ec0",
	"./单向箭头.svg": "f9e3",
	"./商务舱.svg": "fb12",
	"./外链.svg": "f1db",
	"./头像.svg": "a130",
	"./头等舱.svg": "5259",
	"./左滑.svg": "b452",
	"./成功.svg": "ab6e",
	"./打勾.svg": "6a74",
	"./拍照.svg": "b3b3",
	"./推广.svg": "3ecb",
	"./提示.svg": "15ee",
	"./搜索.svg": "085b",
	"./操作取消.svg": "088a",
	"./放大.svg": "b559",
	"./放大2.svg": "c519",
	"./放大_active.svg": "c040",
	"./更多.svg": "b52f",
	"./未登录头像.svg": "0bab",
	"./查看.svg": "68f1",
	"./检品标准.svg": "b190",
	"./照片.svg": "21fd",
	"./登录b2b.svg": "0927",
	"./登录d2c.svg": "d2d9",
	"./移除.svg": "d5ee",
	"./筛选.svg": "cfcb",
	"./箭头.svg": "cd14",
	"./经济舱.svg": "3516",
	"./自动同步采购订单.svg": "4ff7",
	"./解绑.svg": "3d16",
	"./购物车.svg": "385f",
	"./返回-return.svg": "a7c7",
	"./进度条.svg": "512c",
	"./选择要链接商品的SKU.svg": "837ce",
	"./选择要链接的商品.svg": "87f7",
	"./铂金舱.svg": "3dc5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b422";